export default __webpack_public_path__ + "static/media/esports_banner.9fdbfe43.png";